<div class="row justify-content-center align-content-center">
    <div style="padding: 5px" class="emoji-box">
      <div class="count-container">{{clapCount}}</div>
      <button (click)="clap()" class="btn emoji">👏</button>
    </div>
    <div style="padding: 5px" class="emoji-box">
      <div class="count-container">{{laughCount}}</div>
      <button  (click)="laugh()"class="btn emoji">😂</button>
    </div>
    <div style="padding: 5px" class="emoji-box">
      <div class="count-container">{{loveCount}}</div>
      <button (click)="love()" class="btn emoji">😍</button>
    </div>
    <div style="padding: 5px" class="emoji-box">
      <div class="count-container">{{sadCount}}</div>
      <button  (click)="sad()"class="btn emoji">😥</button>
    </div>
    <div style="padding: 5px;" class="emoji-box">
      <div class="count-container">{{flushedCount}}</div>
      <button (click)="flushed()"class="btn emoji">😮</button>
    </div>
    <div style="padding: 5px" class="emoji-box">
      <div class="count-container">{{angryCount}}</div>
      <button (click)="angry()" class="btn emoji">😤</button>
    </div>
  </div>